<template>
    <div class="row">
        <treeselect v-model="clientValue"
                    :clearable="false"
                    placeholder="Bitte Kunde wählen"
                    :options="clientItems"
                    :disableFuzzyMatching="true"
                    :disabled="disabled || isBusy"
                    style="max-width: 609px; margin-left: 35px;">
        </treeselect>
        <b-button variant="primary" size="sm" @click="onContinueButtonClicked" :disabled="disabled || isBusy" class="ml-1">
            {{ $t('Webportal.Continue') }}
        </b-button>
    </div>
</template>

<script>

import AdministationService from '@/services/AdministationService';

export default {
    name: 'ClientSelection',

    components:{

    },

    props: {
        disabled: {type: Boolean, default: false}
    },

    data () {
        return {
            clientItems: [],                   // Data items for client treeselect
            clientValue: undefined,            // Selected client item
            clientSettings: undefined,
            isBusy: false,
        }
    },

    created() {
        // console.log("ClientSelection - created");
        this.getClientSettings();
    },

    methods: {

        getClientSettings() {
            this.isBusy = true;

            AdministationService.getClientSettings(null)
                .then(response => { 
                    this.clientSettings = response.data;
                    this.initializeClientSelection();
                    this.isBusy = false;

                    if (!this.clientValue && this.clientSettings && this.clientSettings.length > 0) {

                        let firstClient = this.clientSettings[0];
                        this.clientValue = firstClient ? firstClient.ClientId : undefined;

                        if (this.clientValue) {
                            this.$emit('clientselectionchanged', this.clientSettings[0]);
                        }
                    }
                })
                .catch(error => {
                    console.warn("Error while receiving client settings: " + error);
                    this.isBusy = false;
                });
        },

        initializeClientSelection() {
            if (this.clientSettings != null) {
                this.clientItems = this.clientSettings.map(item => {
                    return { id: item.ClientId, label: item.ClientName };
                });
            }
        },

        onContinueButtonClicked() {
            var eventRetVal = undefined; 
            
            if (this.clientValue) {
                eventRetVal = this.clientSettings.find(item => item.ClientId === this.clientValue);
                // console.log('ClientSelection - current selected clientID: ' + this.clientValue);
            }
            this.$emit('clientselectionchanged', eventRetVal);
        }
    },

    computed: {

    }
}

</script>

<style>

.row {
  padding: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
}

</style>
